import Dropdown from "./dropdown";
import DropdownItem from "./dropdownItem";
import DropdownMenu from "./dropdownMenu";

Dropdown.Item = DropdownItem;
Dropdown.Menu = DropdownMenu;

export default Dropdown;
